import { Col, Collapse, Row } from "antd";
import { useState } from "react";

import { Box } from "@material-ui/core";

import useOnInitAsync from "../../../hooks/useOnInitAsync";
import { LinkedInBudgetStrategy } from "../../../models/linkedin-manager/strategy/LinkedInBudgetStrategy";
import { linkedinStrategyManagementService } from "../../../services/linkedin/LinkedInStrategyManagementService";
import Loader from "../../general/loader/Loader";
import LinkedInStrategyForm from "./LinkedInStrategyForm";
import LinkedInStrategyCard from "./LinkedInStrategyCard";

const { Panel } = Collapse;

type Props = {
    companyId: string | number;
};

const LinkedInStrategyManagement = (props: Props) => {
    const { companyId } = props;

    const [BudgetStrategies, setBudgetStrategies] =
        useState<LinkedInBudgetStrategy[]>();

    const callback = (key: any) => {};

    useOnInitAsync(async () => {
        const companyStrategies =
            await linkedinStrategyManagementService.GetStrategiesByCompanyId(
                companyId
            );
            setBudgetStrategies(companyStrategies);
    });

    if (!BudgetStrategies) {
        return <Loader position="normal" />;
    }

    return (
        <Box mb={5}>
            <Collapse
                defaultActiveKey={
                    BudgetStrategies.length == 0 ? ["0"] : ["1"]
                }
                /* onChange={callback} */
            >
                <Panel header="Strategy Management" key="1">
                    <Box mt={2} mb={6}>
                        <LinkedInStrategyForm
                            companyId={companyId}
                            onFormSubmitSuccesfully={(newlyCreatedStrategy) => {
                                setBudgetStrategies([
                                    ...BudgetStrategies,
                                    newlyCreatedStrategy,
                                ]);
                            }}
                        />
                    </Box>

                    <Row gutter={[16, 16]}>
                        {BudgetStrategies.map(
                            (BudgetStrategy, index) => (
                                <Col className="gutter-row" span={4}>
                                    <LinkedInStrategyCard
                                        key={index}
                                        linkedinBudgetStrategy={
                                            BudgetStrategy
                                        }
                                        companyId={companyId}
                                        onDelete={(BudgetStrategyId) => {
                                            setBudgetStrategies(
                                                BudgetStrategies.filter(
                                                    (x) => x.id !== BudgetStrategyId
                                                )
                                            );
                                        }}
                                    />
                                </Col>
                            )
                        )}
                    </Row>
                </Panel>
            </Collapse>
        </Box>
    );
};

export default LinkedInStrategyManagement;
